export default class kayttoIkaClass {
  constructor() {
    this.kayttoIkaId = 1;
    this.kayttoIkaSelite = "50v";
    this.kayttoIkaSliderSortId = 1;
  }
  set(obj) {
    this.kayttoIkaId = obj.kayttoIkaId;
    this.kayttoIkaSelite = obj.kayttoIkaSelite;
    this.kayttoIkaSliderSortId = obj.kayttoIkaSliderSortId;
  }
  get kayttoIkaString() {
    {
      return this.kayttoIkaSelite;
    }
  }
}
